<script setup lang="ts">
import { useRouter } from "vue-router";

import Button from "~/components/dumb/Button.vue";
import { UpgradeRequiredIcon } from "~/icons";
import { makeLinkToSettingsRef } from "~/router/common";
import { ButtonSize, ButtonStyle, Subscription } from "~/shared/enums";
import { useTenantStore } from "~/stores";
import { useUpgrade } from "~/utils/billing";

const props = defineProps<{
  subscription: Subscription;
  upgradeOnly?: boolean;
  justify?: "start" | "center" | "end";
}>();

const router = useRouter();
const tenantStore = useTenantStore();

const { upgradeCta, handleUpgradeClick } = useUpgrade(tenantStore, () => props.subscription);

const redirectToBilling = () => router.push(makeLinkToSettingsRef("billing").value);
</script>

<template>
  <div
    class="flex items-center gap-2"
    :class="justify !== undefined ? justify : upgradeOnly ? 'justify-center' : 'justify-end'">
    <Button
      v-if="!upgradeOnly"
      :btn-style="ButtonStyle.SECONDARY"
      text="See plans"
      :size="ButtonSize.LARGE"
      @click="redirectToBilling" />
    <Button
      :btn-style="upgradeOnly ? ButtonStyle.SECONDARY : ButtonStyle.PRIMARY"
      :icon="UpgradeRequiredIcon"
      :text="upgradeCta"
      @click="handleUpgradeClick(props.subscription)" />
  </div>
</template>
